export default __webpack_public_path__ + "static/media/108.e266f0a6.jpg";